import React from 'react'
import addidas from '../../assets/ADIDAS_fp01.png'
const Gift = () => {
    return (
        <div className="gift-article mb-5">
        <div className="container row mt-5">
            <div className="offset-lg-2 hierarchy mb-5">
              <ul>
                  <li>Home</li>
                  <li>Gift Cards</li>
                  <li className="active">Amazon Gift Cards</li>
              </ul>
            </div>
            <div className="offset-lg-2 col-md-3 article">
               
                <div className="item"> 
                    <img src={addidas} alt="addidas"/>

                    <div className="number-input">
                      <label>Select amount</label>
                      <button onclick="decrease(this)"></button>
                      <input type="text" name="amount" className="auto-number" value="$ 5" /> 
                      <button onclick="increase(this)" className="plus"></button>
                    </div>
                      
                    <div className="number-input manual">
                      <label>Or enter an amount between $15 and $150</label>
                      <button onclick="this.parentNode.querySelector('input[type=number]').stepDown()"></button>
                      <input type="number" className="manual-number" placeholder="Enter your amount" /> 
                    </div>  
                </div> 
            </div>
            <div className="offset-md-1 col-md-5">
              <div className="product-infos">
                    <h4>Amazon.com eGift Card</h4>
                    <p><small> Redemption: Online Only</small></p>
                    <p className="disclaimer">The voucher can be redeemed on the websites
                      www.amazon.de. Only users over 16 years old can buy this product</p>
                    <p className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </p>
              </div> 
              <div className="delivary-details">
                  <div className="form-group">
                    <label for="rcp-name">Recipient Name</label>
                    <input type="text" className="form-control" id="rcp-name" placeholder="Recipient Name" /> 
                  </div>
                  <div className="form-group">
                    <label for="rcp-email">Recipient Email</label>
                    <input type="text" className="form-control" id="rcp-email" placeholder="Recipient Email" /> 
                  </div>
                  <div className="form-group">
                    <label for="name">Your name</label>
                    <input type="text" className="form-control" id="name" placeholder="Your name" /> 
                  </div>

                  <div className="form-group ">
                    <label for="message">Message (optinal)</label>
                    <textarea className="form-control" placeholder="Message"> </textarea>
                  </div>

                  <div className="form-group">
                    <label for="message">Delivery</label>
                    <input type="text" className="form-control" id="name" placeholder="Delivery" /> 
                  </div>

                  <button className="btn-yellow w-100">Add to basket </button></div>
            </div> 
        </div>
    </div>
    )
}

export default Gift
